import React, { useRef } from 'react';
import { connect } from 'react-redux';
import {  Navigate, Link } from 'react-router-dom'
import axios from 'axios'
import Server from './Server.js'
class Header extends React.Component {
	constructor(props) {
		super(props);
		this.op = React.createRef();
		this.Server = new Server();
		this.state = {
			Exit:this.props.Exit,
			small:this.props.small,
			login:false,
			absoluteUrl: this.Server.getAbsoluteUrl(),
			systemCode: this.Server.getSystem() ? this.Server.getSystem().code : null,
			url: this.Server.getUrl(),
			appData: this.props.appDataParam||this.props.appData
		}
	}
	componentDidMount() {
		this.setState({
			credit : this.props.credit
		  })
		  axios.post(this.state.url + 'checktoken', {
            token: localStorage.getItem("api_token")
        })
            .then(response => {
				this.setState({
					login:true
				})
				this.props.dispatch({
					type: 'LoginTrue',
					LoginAnia:this.props.username ? false : true,
					username: this.props.username,
					password: this.props.password,
					account: this.props.account,
					place: this.props.place,
					ip: this.props.ip,
					mobile: this.props.mobile ? this.props.mobile : (response.data.authData ? response.data.authData.username : null) ,
					fullname: this.props.fullname ? this.props.fullname : (response.data.authData ? (response.data.authData.name||response.data.authData.username):null),
					tokenrb: this.props.tokenrb,
    				appData: this.props.appData,
					creditPrice: this.props.creditPrice,
					systemId: this.props.systemId
				  })
				  if(!(this.state.appData && this.state.appData.lName) && this.state.systemCode){
					this.getAppData(this.state.systemCode);
				  }
                
            })
            .catch(error => {
                this.setState({
                  login:true
                })
            })
		 
	  }

	  getAppData(systemCode) {
		let that = this;
		this.setState({
		  ShowLoading: true,
		});
		let SCallBack = function (response) {
		  const appData = response.data.result[0] || {};
		  that.setState({
			appData: appData,
		  });
		};
		let ECallBack = function (error) {
		 
		};
		const condition = { condition: { code: systemCode } };
		this.Server.send("MainApi/getAppData", condition, SCallBack, ECallBack);
	  }

	render() {
		if (this.state.GotoLogin) {
			return <Navigate to={"/"} />;
		}
		if (this.state.GotoPage) {
			return <Navigate to={this.state.GotoPage} />;
		}
		return (
			this.props.noBack ?
			<div>
				<div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
						<div style={{ backgroundColor: '#fff', height: 60, width: '75%', borderBottomLeftRadius: 25, borderBottomRightRadius: 25, display: 'flex', alignItems: 'center', justifyContent: 'space-around' }}>
							<div style={{ width: '60%' }}>
							<img src={`./icons/${this.state.appData?.lName}/top-logo.png`} style={{ width: '100%' }} />
							</div>
							<div style={{ width: '25%' }}>
							<img src={`./icons/${this.state.appData?.lName}/logo.png`} style={{ width: 40 }} />
							</div>
						</div>
				</div>
			</div>
			:
			<div className="sarv-bg1 sarv-home-top-box">
				<div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
						<div style={{ backgroundColor: '#fff', height: 60, width: '75%', borderBottomLeftRadius: 25, borderBottomRightRadius: 25, display: 'flex', alignItems: 'center', justifyContent: 'space-around' }}>
							<div style={{ width: '60%' }}>
							<img src={`./icons/${this.state.appData?.lName}/top-logo.png`} style={{ width: '100%' }} />
							</div>
							<div style={{ width: '25%' }}>
							<img src={`./icons/${this.state.appData?.lName}/logo.png`} style={{ width: 40 }} />
							</div>
						</div>
				</div>
				<div style={{height:15}} ></div>
				<div style={{display:'flex',justifyContent:'space-between',backgroundColor: '#fff',alignItems:'center',paddingLeft:10,paddingRight:10,height:(this.props.height)}}>
					
					
					<div>
						{!this.props.close ?
					<span style={{padding:10}} className="fa fa-arrow-left sarv-title2" onClick={()=>{
						if(this.props.callback)
							this.props.callback({});
						if(this.state.Exit){
							this.setState({
								GotoLogin:1
							})
						}else{
							window.history.back();
						}
					}}></span>
					:
					<span style={{padding:5}} className="fas fa-window-close sarv-title2" onClick={()=>{
							if(this.props.callback)
								this.props.callback({});

							this.setState({
								GotoPage:'/Home'
							})
					}}></span>

				}
					</div>
				<div>
					<div className="iranyekanwebmedium" style={{fontSize:20,direction:'rtl',whiteSpace:'nowrap',textOverflow:'ellipsis',width:'100%',overflow:'hidden'}} className="sarv-title2"> {this.props.ComponentName}
					</div>
				</div>
				<div>
					{this.props.ComponentLName &&
						<img src={`./icons/${this.state.appData?.lName}/${this.props.ComponentLName}.png`} style={{width:30}} />
					}
					
				</div>
			

					
					

				</div>
			</div>
			
		)
	}
}
function mapStateToProps(state) {        
	return {
        username: state.username,
        password: state.password,
        ip: state.ip,
        account: state.account,
        place: state.place,
        fullname: state.fullname,
		tokenrb: state.tokenrb,
        mobile: state.mobile,
        LoginAnia:state.LoginAnia,
		appData:state.appData,
		creditPrice:state.creditPrice,
		systemId:state.systemId
    }
  }
  export default connect(mapStateToProps)(Header) 
